import { put, select } from 'redux-saga/effects';
import EasyRedux from '../../utils/EasyRedux';
import handleSagaError from '../handleSagaError';

const key = 'MERCHANT/APP/SLIDER/LIST';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchGetAppSliderList(
  client,
  { payload: { siteId, resolve, reject } }
) {
  try {
    const userSiteId = yield select((state) => state?.userSite?.data?._id);
    const response = yield client.post('/merchant/slider/list', {
      data: {
        site: siteId || userSiteId,
        type: 4,
      },
    });
    yield put(actions.loadSuccess(response.result));
    resolve && resolve(response.result);
  } catch (e) {
    reject && reject(e);
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
